import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import _ from "lodash";
import styled from "styled-components";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { DateDisplay } from "../../../components";
import CompletedReviewTableStatusIconColumn from "./CompletedReviewTableStatusIconColumn";

const CompletedReviewsTableRowColumn = styled.td`
    padding: 0.6rem !important;
    vertical-align: middle;
    width: ${({ width }) => width}%;
`;

const CompletedReviewsTableRow = ({ data, index, style }) => {

    const openMasterAccount = useOpenMasterAccount();

    // do not return a data row when the data has not yet been collected from the backend
    if (index >= data.length) {
        return <TableLoadingRow />;
    }

    const {
        reviewId,
        masterAccountId,
        masterAccountReference,
        masterAccountName,
        reviewAdviserId,
        reviewAdviser,
        reviewDate,
        reviewStatus,
        reviewStatusComment,
        isDrawdownReview,
        reviewScore,
        delayed,
        followUpSentDate,
        previousFollowUpSentDate,
        createdDate,
        isActive
    } = data[index];

    const handleOpenMasterAccount = (e) => {
        if (e && typeof e.preventDefault === "function") {
            e.preventDefault();
        }
        openMasterAccount(masterAccountId, { suffix: "reviews" });
    };

    return (
        <tr>
            {/* Client Name Display */}
            <CompletedReviewsTableRowColumn width={35}>
                <a href={`/client/${masterAccountId}/reviews`} onClick={handleOpenMasterAccount}>
                    <span>
                        {masterAccountReference} - {masterAccountName}
                    </span>
                </a>
            </CompletedReviewsTableRowColumn>
            <CompletedReviewsTableRowColumn width={20}>
                <span>{reviewAdviser}</span>
            </CompletedReviewsTableRowColumn>
            <CompletedReviewsTableRowColumn width={13}>
                <span><DateDisplay>{reviewDate}</DateDisplay></span>
            </CompletedReviewsTableRowColumn>
            <CompletedReviewsTableRowColumn width={13}>
                <span><DateDisplay>{followUpSentDate}</DateDisplay></span>
            </CompletedReviewsTableRowColumn>
            <CompletedReviewsTableRowColumn width={13}>
                <span><DateDisplay>{previousFollowUpSentDate}</DateDisplay></span>
            </CompletedReviewsTableRowColumn>
            <CompletedReviewTableStatusIconColumn reviewScore={reviewScore} />
        </tr>
    );
};

export default CompletedReviewsTableRow;
